import { FC, PropsWithChildren } from 'react'

import './TextContent.css'

export const TextContent: FC<PropsWithChildren> = ({ children }) => <div className="textContent">{children}</div>
